<template>
  <Card :bordered="false" dis-hover class="card-box">
    <div slot="title" style="display: flex; flex-direction: row; justify-content: space-between; align-items: center">
      <div class="line-limit-length line-value" style="display: flex; flex-direction: row;">
        <span class="line-info-item">{{agent.hostname}}</span>
        <span class="line-info-item">{{agent.os}}</span>
        <span class="line-info-item">{{agent.arch}}</span>
      </div>
      <span style="width:24px;cursor:pointer;" v-if="!agent.online" @click="removeClient(agent.client_id)">
        <Icon type="ios-trash" :size="18" />
      </span>
      <Tag color="green" v-if="agent.online">Online</Tag>
      <Tag color="gray" v-if="!agent.online">Offline</Tag>
    </div>
    <div style="display: flex; flex-direction: column; align-items: flex-start">
      <div style="display: flex; flex-direction: row;">
        <div class="line-label">ID:</div>
        <div class="line-limit-length line-value">
          <a @click="openXterm(agent.client_id)" target="_blank">{{agent.client_id}}</a>
        </div>
      </div>
      <div style="display: flex; flex-direction: row;">
        <div class="line-label">公网IP:</div>
        <div class="line-limit-length line-value">
          <span>{{agent.ip}}</span>
          <span style="margin-left:5px;">{{(agent.area&&agent.area!=="")?"("+agent.area+")":""}}</span>
        </div>
      </div>
      <div style="display: flex; flex-direction: row;">
        <div class="line-label">网卡IP:</div>
        <div class="line-limit-length line-value" style="display: flex; flex-direction: column">
          <span v-for="(ip, idx) in agent.ipins" :key="idx">{{ip}}</span>
        </div>
      </div>
      <div style="display: flex; flex-direction: row;">
        <div class="line-label">备注:</div>
        <div class="line-value">{{agent.memo}}</div>
      </div>
    </div>
  </Card>
</template>

<script>
export default {
  name: 'AgentCard',
  props: ['agent', 'deleteItemCallback'],
  methods: {
    openXterm (id) {
      this.$router.push('/machine/xterm?id=' + id)
    },
    removeClient (id) {
      console.log('id:', id)
      this.deleteItemCallback(id)
    }
  }
}
</script>

<style scoped>
  .card-box {
    width:350px;
    margin:5px;
  }
  .line-label {
    width: 50px;
    text-align: right;
    margin-right: 13px;
  }
  .line-limit-length {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .line-value {
    width: 250px;
    text-align: left;
  }
  .line-info-item {
    margin-right: 15px;
  }
</style>
